import { render, staticRenderFns } from "./BootstrapModal.vue?vue&type=template&id=4f423d5d&"
import script from "./BootstrapModal.vue?vue&type=script&lang=js&"
export * from "./BootstrapModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports